module.exports = __webpack_public_path__ + "img/worm-folded-mask.89f3fcaa.png";